import {Localizer} from "../../../infrastructure/localization/localizer";
import React, {useState} from "react";
import useScreenResolution from "../../../core/hooks/useScreenResolution";
import DashboardCardSettings from "../dashboardCardSettings";
import useDashboardVejledersamtaler from "./useDashboardVejledersamtaler";
import classNames from "classnames";
import {Loading} from "../../../core/components/loading/loading";
import {EmblaIllustration} from "../../../core/components/emblaIcon/emblaIllustration";
import MultiLevelPieChart from "../dashboardCharts/multiLevelPieChart";
import {LegendPlacement} from "../models/LegendPlacement";
import {DashboardCardSettingsOption} from "../models/DashboardCardSettingsOption";
import {SimpleBarChart} from "../dashboardCharts/simpleBarChart";

type DashboardVejledersamtalerProps = {}
const DashboardVejledersamtaler = ({}: DashboardVejledersamtalerProps) => {
    const {isMobile} = useScreenResolution();
    const [showLabelsVejledersamtaler, setShowLabelsVejledersamtaler] = useState<boolean>(false);

    const {
        setShowIkkePlanlagte,
        showIkkePlanlagte,
        introduktionPieChart,
        justerendePieChart,
        afsluttendePieChart,
        isLoading,
        vejledersamtalerTotalAmount,
        introduktionTotalAmount,
        justerendeTotalAmount,
        afsluttendeTotalAmount,
        vejledersamtalerTidSidenSidste,
        vejledersamtalerTidSidenSidsteTotalAmount,
        justerendeVejledersamtalerBarChart,
    } = useDashboardVejledersamtaler();

    const noResults = vejledersamtalerTotalAmount <= 0 && !isLoading;

    const settingsOption: DashboardCardSettingsOption[] = [
        {
            checkedValue: showLabelsVejledersamtaler,
            setCheckedValue: setShowLabelsVejledersamtaler,
            label: Localizer.dashboard_showLabelValues()
        },
        {
            checkedValue: showIkkePlanlagte,
            setCheckedValue: setShowIkkePlanlagte,
            label: Localizer.dashboard_showNotPlanned(),
        }
    ];


    return <>
        <div className="card">
            <div className="card-header">
                <h4 className="card-title">{Localizer.global_vejledersamtaler()}</h4>
                <DashboardCardSettings id={"settings-vejledersamtaler-icon-id"}
                                       options={settingsOption}/>
            </div>
            <div className={classNames("card-body d-flex", noResults && "justify-content-center")}>
                <Loading isLoading={isLoading} text={Localizer.global_vejledersamtaler()} hideContentOnPreload={false}>
                    {noResults
                        ?
                        <div className={"flex-container-column align-items-center  padding-m"}>
                            <EmblaIllustration illustrationName={"failure-mark"} additionalClasses={"subtle"}/>
                            <h4 className={"subtle"}> {Localizer.global_NoResultsFromFilter()} </h4>
                        </div>
                        :
                        <>
                            <div className={classNames("flex-container-column wrap fill-card")}>
                                <div
                                    className={classNames("flex-container-row wrap flex-space-between margin-bottom-m", isMobile && "justify-content-center")}>
                                    <div
                                        className={classNames("flex-container-row fill-card wrap justify-content-center", !isMobile && "border dashboard-card-border-radius", isMobile && "justify-content-center")}>
                                        <MultiLevelPieChart datasets={introduktionPieChart}
                                                            diagramTitle={Localizer.global_introduktion()}
                                                            totalAmount={introduktionTotalAmount}
                                                            showLabels={showLabelsVejledersamtaler}
                                                            overrideInnerRadius={0}
                                                            legendPlacement={LegendPlacement.Bottom}
                                                            showLegendLabels={false}
                                                            showCenterLabel
                                        />
                                        <MultiLevelPieChart datasets={justerendePieChart}
                                                            diagramTitle={Localizer.global_justerende()}
                                                            totalAmount={justerendeTotalAmount}
                                                            showLabels={showLabelsVejledersamtaler}
                                                            overrideInnerRadius={0}
                                                            legendPlacement={LegendPlacement.Bottom}
                                                            showLegendLabels={false}
                                                            showCenterLabel
                                        />
                                        <MultiLevelPieChart datasets={afsluttendePieChart}
                                                            diagramTitle={Localizer.global_afsluttende()}
                                                            totalAmount={afsluttendeTotalAmount}
                                                            showLabels={showLabelsVejledersamtaler}
                                                            overrideInnerRadius={0}
                                                            legendPlacement={LegendPlacement.Bottom}
                                                            showLegendLabels={false}
                                                            showCenterLabel
                                        />
                                    </div>
                                </div>
                                <div className={"flex-container-row wrap flex-space-between"}>
                                    <div
                                        className={classNames("align-content-center", !isMobile && "border dashboard-card-border-radius graph-w-49", isMobile && "flex-fill")}>
                                        <div className={classNames(!isMobile && "margin-m")}>
                                            <h4>{Localizer.dashboard_justerendeVejledersamtaleAmount()}</h4>
                                        </div>
                                        <Loading isLoading={isLoading}
                                                 text={Localizer.dashboard_justerendeVejledersamtaleAmount()}
                                                 hideContentOnPreload={false} spinnerClasses={"margin-m"}>
                                            {justerendeVejledersamtalerBarChart &&
                                                <SimpleBarChart dataset={justerendeVejledersamtalerBarChart}
                                                                totalAmount={justerendeTotalAmount}
                                                                hideLegends
                                                                xLabel={Localizer.dashboard_justerendeVejledersamtaleAmount()}
                                                                yLabel={Localizer.global_uddannelseslaeger()}
                                                />
                                            }
                                        </Loading>
                                    </div>
                                    <div className={classNames("align-content-center", !isMobile && "border dashboard-card-border-radius flex-row-center fill-card")}>
                                        <MultiLevelPieChart
                                            datasets={vejledersamtalerTidSidenSidste}
                                            diagramTitle={Localizer.dashboard_tidSenesteSidsteVejledersamtale()}
                                            totalAmount={vejledersamtalerTidSidenSidsteTotalAmount}
                                            showLabels={showLabelsVejledersamtaler}
                                            overrideInnerRadius={0}
                                            legendPlacement={LegendPlacement.Right}
                                            showLegendLabels={false}
                                            showCenterLabel
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </Loading>
            </div>
        </div>
    </>
}
export default DashboardVejledersamtaler;
